<template>
  <v-container class="entry" wrap>
    <div>
      <span class="title">{{ formatDateToHeaderDisplay(propReportDate) }}</span>
    </div>

    <v-form ref="formEdit" v-model="valid" lazy-validation>
      <v-row dense>
        <v-col class="pl-10" cols="4">
          <v-switch
            v-model="editData.allDay"
            :label="'終日'"
            :value="1"
          ></v-switch>
        </v-col>

        <v-col cols="3" v-show="!editData.allDay">
          <v-text-field
            label="開始時間"
            value=""
            type="time"
            v-model="editData.startTime"
          ></v-text-field>
        </v-col>
        <v-col cols="1" v-show="!editData.allDay">
          <v-container bg fill-height grid-list-md text-xs-center>
            <v-layout row wrap align-center>
              <v-flex> 〜 </v-flex>
            </v-layout>
          </v-container>
        </v-col>
        <v-col cols="3" v-show="!editData.allDay">
          <v-text-field
            label="終了時間"
            value=""
            type="time"
            v-model="editData.endTime"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="pl-10 pr-10">
          <v-text-field
            :label="titleTitle"
            placeholder=""
            v-model="editData.title"
            :counter="50"
            maxlength="50"
            :rules="titleRule"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- 拡張コンテンツの入力欄 -->
      <v-row
        dense
        v-for="(exCont, ecIdx) in editData.extraContents"
        :key="ecIdx"
      >
        <v-col class="pl-10 pr-10">
          <v-textarea
            :label="exCont.caption"
            value=""
            hint=""
            v-model="exCont.content"
            auto-grow
            :counter="1000"
            maxlength="1000"
            required
          ></v-textarea>
        </v-col>
      </v-row>

      <!-- 標準コンテンツの入力欄（内容 / その他） -->
      <v-row dense>
        <v-col class="pl-10 pr-10">
          <v-textarea
            name="input-7-1"
            :label="defaultContentTitle"
            value=""
            hint=""
            v-model="editData.content"
            auto-grow
            :counter="2000"
            maxlength="2000"
            :rules="defaultContentRule"
          ></v-textarea>
        </v-col>
      </v-row>

      <!--
      <v-row dense>
        <v-col class="pl-10 pr-10">
          <v-select
                  :items="customers"
                  label="得意先/仕入先"
          ></v-select>
        </v-col>
      </v-row>
-->
      <v-row dense class="pl-10">
        <v-col class="" cols="12" dense>
          <v-radio-group class="pa-0 ma-0" v-model="editData.goodOrBad" row>
            <v-radio label="通常" value="N" />
            <v-radio label="GoodNews" color="blue" value="G" />
            <v-radio label="BadNews" color="red" value="B" />
          </v-radio-group>
        </v-col>

        <v-col class="" cols="12" dense>
          <v-radio-group class="pa-0 ma-0" v-model="editData.importance" row>
            <v-radio label="通常" value="0" />
            <v-radio label="重要" color="blue" value="1" />
            <v-radio label="最重要" color="orange" value="2" />
            <v-radio label="緊急" color="red" value="3" />
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="pl-10 pr-10" cols="12" sm="6">
          <v-text-field label="タグ" placeholder="" v-model="editData.inputTag">
            <template v-slot:append-outer>
              <v-btn v-on:click="onAddTagBtnClick">追加</v-btn>
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <!--
          <v-chip @click="onImportantBtnClick" class="mb-2 mr-2">
            <v-icon left>add_circle_outline</v-icon>
            重要
          </v-chip>
          -->
          <v-chip
            class="mr-2 mb-2"
            v-for="tag in tag_ac.autocompleteList"
            @click="onTagChipClick(tag)"
          >
            <v-icon left>add_circle_outline</v-icon>
            {{ tag }}
          </v-chip>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="pl-10 pr-10">
          <div class="report_tags">
            <span
              v-for="(tag, tagIdx) in editData.tags"
              class="chip_container"
              :key="tagIdx"
            >
              <v-chip close @click:close="onDeleteTag(tagIdx)">{{
                tag
              }}</v-chip>
            </span>
          </div>
        </v-col>
      </v-row>

      <!--
      <v-row dense>
        <v-col class="pl-10">
          <UserSelectField label="お知らせしたい人" :value="editData.notify_user_id"></UserSelectField>
        </v-col>
      </v-row>
      -->

      <!--
      <v-row dense>
        <v-col class="pl-10 pr-10">
          <v-file-input v-model="selected_file" label="添付ファイル" @change="onFileInputChanged"></v-file-input>
        </v-col>
      </v-row>
      -->

      <v-row dense>
        <v-col class="pl-10 pr-10 mt-5">
          <ReportFileInputBox
            :fileIds="editData.files"
            @delete="onFileDeleteClick"
            @drop="onFileDrop"
          ></ReportFileInputBox>
        </v-col>
      </v-row>

      <v-divider class="mb-3 mt-3"></v-divider>
      <v-row dense
        ><!--  justify="space-between" -->

        <!--<v-col class="pl-10">
            <v-btn v-on:click.prevent="onDeleteBtnClick" color="error">削除</v-btn>
        </v-col>-->

        <v-col class="pl-10">
          <v-btn
            v-on:click.prevent="onSaveBtnClick(1)"
            color="primary"
            class="mr-3 mb-3"
            >保存</v-btn
          >
          <v-btn
            v-if="canDraftSave"
            v-on:click.prevent="onSaveBtnClick(2)"
            class="mr-3 mb-3"
            >下書保存</v-btn
          >
          <v-btn v-on:click.prevent="onCancelBtnClick" class="mr-3 mb-3"
            >キャンセル</v-btn
          >
        </v-col>
        <v-col align="right">
          <v-btn v-if="isEditMode" v-on:click.prevent="onDeleteBtnClick"
            >削除</v-btn
          >
        </v-col>
      </v-row>
    </v-form>

    <ConfirmDialog ref="deleteConfirmDialog"></ConfirmDialog>
  </v-container>
</template>

<script>
import Common from "@/components/Common";
import ReportEntryAPI from "@/apis/ReportEntryAPI";
import FileUploadAPI, { MAX_FILE_SIZE_MB, MAX_FILE_SIZE_BYTES } from "@/apis/FileUploadAPI";
import TagAPI from "@/apis/TagAPI";
import DateInputField from "../components/controls/DateInputField";
import TimeInputField from "../components/controls/TimeInputField";
import UserSelectField from "../components/controls/UserSelectField";
import ReportFileInputBox from "./sub/ReportFileInputBox";
import ConfirmDialog from "../components/dialogs/ConfirmDialog";
import RoleSupport from "@/components/RoleSupport";

export default {
  mixins: [Common, RoleSupport],
  components: {
    DateInputField,
    TimeInputField,
    UserSelectField,
    ReportFileInputBox,
    ConfirmDialog,
  },
  mounted: function () {
    this.availableExtraContentCodes.splice(0);
    if (window.app.util.checkEnvFlag(window.app.env.VUE_APP_USE_REP_EXCONTENT)) {
      // 表示対応のコンテントコードを求める
      let exCodes = (window.app.env.VUE_APP_USE_REP_EXCONTENT_CODES ?? "").split(",").map((t) => t.trim()).filter((t) => t.length > 0);        
      if (!exCodes || exCodes.length == 0) {
        // 空だったら全てを対象とする
        exCodes = this.extraContentCodes.map((t) => t.cd);          
      }
      console.log("exCodes", exCodes)
      this.availableExtraContentCodes.push(...exCodes)
      
      // extraContentCodesをフィルタする
      const tmpcodes = this.extraContentCodes.filter((t) => exCodes.includes(t.cd))
      this.extraContentCodes.splice(0);
      this.extraContentCodes.push(...tmpcodes);

      // 入力欄用のデータを作成
      this.editData.extraContents = [];
      this.extraContentCodes.forEach((excnt) => {
        this.editData.extraContents.push({
          content_no: this.editData.length,
          content_type: excnt.cd,
          content: "",
          caption: excnt.caption,
        });
      });
    } else {
      this.extraContentCodes.splice(0);
    }      



    if (this.propReportId !== null && this.propReportId > "0") {
      this.fetchData(true);
      this.tagSearch("");
    } else {
      this.fetchData(false);
      this.tagSearch("");
      if (window.app.util.checkEnvFlag(window.app.env.VUE_APP_USE_REP_TEMPLATE)) {
        //console.log(
        //  "process.env.VUE_APP_USE_REP_TEMPLATE = True",
        //  process.env.VUE_APP_USE_REP_TEMPLATE
        //);
        this.editData.content = "";
      } else {
        console.log("process.env.VUE_APP_USE_REP_TEMPLATE = False");
      }

    }
  },
  watch: {
    "editData.inputTag"(val) {
      // val には入力中の値が入ってくる
      this.tagSearch(val);

      //if (val !== this.tag_ac.search){
      //  this.tagSearch(val);
      //  //this.editData.inputTag = val;
      //}
    },
  },
  props: {
    propReportId: Number,
    propReportDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      menu: false,
      menu2: false,
      menu3: false,

      reportDate: "",

      customers: ["小松ss粟津工場", "室戸鉄工所", "ダイワ"],

      staffs: ["丹羽常務", "田中課長", "番匠課長"],

      editData: {
        sourceIdx: 0,
        reportType: "A",
        report_type: "A",
        dt: null,
        startTime: null,
        start_time: null,
        endTime: null,
        end_time: null,
        title: "",
        content: "",
        staffCd: "",
        staff_cd: "",
        tags: [],
        allDay: 1,
        all_day: 1,

        notifyUserId: "",
        notify_user_id: "",
        inputTag: "",
        files: [],
        state: 1,
        scopeType: 0,
        scope_type: 0,
        goodOrBad: "N",
        importance: "0",
        extraContents: [],
      },
      availableExtraContentCodes: [],

      extraContentCodes: [
        {
          cd: "A1",
          caption: "気付き／課題／提案／バッドニュース",
        },
        {
          cd: "A2",
          caption: "ポジティブストーリー（グッドニュース／感謝など）",
        },
        {
          cd: "A3",
          caption: "今日のトピックス（業務内容、出張報告、取引先情報など）",
        },
        {
          cd: "A4",
          caption: "KPI進捗状況",
        },
      ],

      userFilter: "",

      selected_file: null,

      tag_ac: {
        entries: [],
        isLoading: false,
        model: null,
        search: null,

        autocompleteList: [],

        needReload: false,
      },

      isInitialized: false,
      isFetched: false,

      updating: false,

      valid: true,
      validateRules: {
        titleRules: [
          //(v) => !!v || "タイトルは必須項目です",
          (v) =>
            !v || v.length <= 50 || "タイトルは50文字以内で入力してください",
        ],
        contentRules: [
          //(v) => !!v || "内容は必須項目です",
          (v) =>
            !v || v.length <= 2000 || "内容は2000文字以内で入力してください",
        ],
      },
    };
  },
  computed: {
    fields() {
      return [{}, {}, {}];
    },

    isEditMode() {
      if (this.propReportId !== null && this.propReportId > "0") {
        return true;
      } else {
        return false;
      }
    },

    canDraftSave() {
      if (!this.propReportId || this.editData.state == 2) {
        return true;
      } else {
        return false;
      }
    },

    titleTitle() {
      if (window.app.util.checkEnvFlag(window.app.env.VUE_APP_USE_REP_EXCONTENT)) {
        return "タイトル（省略可能）";
      } else {
        return "タイトル";
      }
    },
    titleRule() {
      if (window.app.util.checkEnvFlag(window.app.env.VUE_APP_USE_REP_EXCONTENT)) {
        return [
          (v) =>
            !v || v.length <= 50 || "タイトルは50文字以内で入力してください",
        ];
      } else {
        return [
          (v) => !!v || "タイトルは必須項目です",
          (v) =>
            !v || v.length <= 50 || "タイトルは50文字以内で入力してください",
        ];
      }
    },
    defaultContentTitle() {
      if (window.app.util.checkEnvFlag(window.app.env.VUE_APP_USE_REP_EXCONTENT)) {
        return "その他";
      } else {
        return "内容";
      }
    },
    defaultContentRule() {
      if (window.app.util.checkEnvFlag(window.app.env.VUE_APP_USE_REP_EXCONTENT)) {
        return [
          (v) =>
            !v || v.length <= 2000 || "内容は2000文字以内で入力してください",
        ];
      } else {
        return [
          (v) => !!v || "内容は必須項目です",
          (v) =>
            !v || v.length <= 2000 || "内容は2000文字以内で入力してください",
        ];
      }
    },
  },
  methods: {
    fetchData(needDataFetch) {
      let self = this;

      if (!this.isInitialized) {
        this.fetchBasicData(function () {
          self.fetchData(needDataFetch);
        });
        return;
      }

      if (needDataFetch) {
        this.loading = true;

        let reportId = this.propReportId;

        this.checkAuthToken()
          .then((a) => {
            return ReportEntryAPI.getEntry(reportId).then((response) => {
              self.makeDisplayData(response.data);
              self.loading = false;
            });
          })
          .catch(function (err) {
            console.log(err);
            self.loading = false;
            self.showErrorToast("データの取得に失敗しました。");
          });
      }
    },

    fetchBasicData(finishProc) {
      this.isInitialized = true;
      if (finishProc) {
        finishProc();
      }
    },

    makeDisplayData(data) {
      //console.log(data);
      let self = this;
      // 旧API(data.report) / 新API({data,meta}) / 新API(data本体) の両形式を受け付ける
      let payload = data && data.data ? data.data : data || {};
      let report = payload.report || payload || {};
      let tags = payload.tags || report.tags || [];
      let extraContents =
        payload.extraContents ||
        payload.extra_contents ||
        report.extraContents ||
        report.extra_contents ||
        report.sections ||
        [];
      // 新API sections(type/text) と旧API extraContents(contentType/content) を同一形式へ正規化
      extraContents = (extraContents || []).map((it) => ({
        contentType:
          it.contentType || it.content_type || it.type || it.sectionType || "",
        content: it.content || it.text || "",
      }));
      let author = payload.author || report.author || {};
      let timeRange =
        payload.timeRange ||
        payload.time_range ||
        report.timeRange ||
        report.time_range ||
        null;
      let attributes = payload.attributes || report.attributes || {};
      let attachments = payload.attachments || report.attachments || [];
      let reportType = report.reportType || report.report_type || "A";
      let reportDate =
        report.reportDate ||
        report.report_date ||
        report.date ||
        this.propReportDate;
      let summary = report.summary || report.content || "";
      let allDayValue = report.allDay;
      if (allDayValue === undefined || allDayValue === null) {
        allDayValue = report.all_day;
      }
      if (allDayValue === undefined || allDayValue === null) {
        // 新APIでは timeRange が無い場合を終日扱いにする
        allDayValue = !timeRange ? 1 : 0;
      } else if (typeof allDayValue === "boolean") {
        allDayValue = allDayValue ? 1 : 0;
      }

      this.editData.reportType = reportType;
      this.editData.report_type = reportType;
      this.editData.dt = reportDate;
      this.editData.startTime =
        report.startTime ||
        report.start_time ||
        (timeRange ? timeRange.start : null);
      this.editData.start_time = this.editData.startTime;
      this.editData.endTime =
        report.endTime ||
        report.end_time ||
        (timeRange ? timeRange.end : null);
      this.editData.end_time = this.editData.endTime;
      this.editData.title = report.title || "";
      this.editData.content = summary;
      this.editData.staffCd =
        payload.staffCd ||
        payload.staff_cd ||
        author.staffCd ||
        author.staff_cd;
      this.editData.staff_cd = this.editData.staffCd;
      this.editData.allDay = allDayValue;
      this.editData.all_day = this.editData.allDay;
      this.editData.state =
        report.state !== undefined && report.state !== null ? report.state : 1;
      // 「上長のみ」公開は廃止したため、既存の日報も標準（0）として保存する（SPEC-038）
      this.editData.scopeType = 0;
      this.editData.scope_type = 0;
      this.editData.files = (payload.files || attachments || [])
        .map((a) => {
          if (typeof a === "object" && a !== null) {
            return Number(a.fileId || a.file_id);
          }
          return Number(a);
        })
        .filter((id) => !Number.isNaN(id) && id > 0);

      this.editData.goodOrBad =
        payload.goodOrBad || attributes.goodBad || attributes.good_bad;
      this.editData.importance = payload.importance || attributes.importance;

      if (!this.editData.goodOrBad) {
        this.editData.goodOrBad = "N";
      }
      if (!this.editData.importance) {
        this.editData.importance = "0";
      }

      this.editData.tags = [];
      tags.forEach((t) => {
        this.editData.tags.push(t.name);
      });

      this.editData.extraContents = [];
      if (window.app.util.checkEnvFlag(window.app.env.VUE_APP_USE_REP_EXCONTENT)) {
        this.extraContentCodes.forEach((excnt) => {
          let cd = excnt.cd;
          let ec = extraContents.find((it) => it.contentType == cd);
          if (ec) {
            this.editData.extraContents.push({
              contentNo: this.editData.length,
              contentType: ec.contentType,
              content_no: this.editData.length,
              content_type: ec.contentType,
              content: ec.content,
              caption: excnt.caption,
            });
          } else {
            this.editData.extraContents.push({
              contentNo: this.editData.length,
              contentType: cd,
              content_no: this.editData.length,
              content_type: cd,
              content: "",
              caption: excnt.caption,
            });
          }
        });
      }

      console.log("this.editData", this.editData);
    },

    onAddTagBtnClick() {
      let tag = this.editData.inputTag;

      if (tag && this.editData.tags.indexOf(tag) === -1) {
        this.editData.tags.push(tag);
        this.editData.inputTag = "";
        this.tag_ac.search = "";
      }
    },

    onTagChipClick(tag) {
      if (this.editData.tags.indexOf(tag) === -1) {
        this.editData.tags.push(tag);
      }
    },

    onImportantBtnClick() {
      let tag = "重要";
      this.onTagChipClick(tag);
    },

    onDeleteTag(idx) {
      this.editData.tags.splice(idx, 1);
    },

    onSaveBtnClick(state) {
      let self = this;

      let formValid = this.$refs.formEdit.validate();

      if (!formValid) {
        console.log("入力内容に不備があります");
        self.showMessageToast("入力内容に不備があります");
        return;
      }

      this.editData.staffCd = this.account.staffCd || this.account.staff_cd;
      this.editData.staff_cd = this.editData.staffCd;

      if (this.updating) {
        return;
      }

      this.updateReport(this.editData, state, function () {
        self.showMessageToast("日報を入力しました。");
        self.backToList();
      });
    },

    onCancelBtnClick() {
      this.backToList();
    },

    async onDeleteBtnClick() {
      let self = this;

      let dialog = this.$refs.deleteConfirmDialog;

      let reportId = this.propReportId;

      if (await dialog.open("確認", "削除してもよろしいですか？")) {
        Promise.resolve()
          .then((a) => {
            this.checkAuthToken();
          })
          .then((a) => {
            return ReportEntryAPI.delete(reportId);
          })
          .then((a) => {
            self.showMessageToast("日報を削除しました。");

            self.backToList();
          })
          .catch(function (err) {
            console.log(err);
            self.showErrorToast("データの削除に失敗しました。");
          });
      }
    },

    updateReport(data, state, finishCb) {
      let self = this;
      let reportDate = this.propReportDate;

      self.updating = true;

      let updateData = {
        reportType: data.reportType || data.report_type,
        report_type: data.reportType || data.report_type,
        dt: reportDate,
        startTime: data.startTime || data.start_time,
        start_time: data.startTime || data.start_time,
        endTime: data.endTime || data.end_time,
        end_time: data.endTime || data.end_time,
        title: data.title,
        content: data.content,
        staffCd: data.staffCd || data.staff_cd,
        staff_cd: data.staffCd || data.staff_cd,
        tags: data.tags,
        allDay: data.allDay || data.all_day,
        all_day: data.allDay || data.all_day,
        files: data.files,
        state: state,
        // 公開範囲は標準（0）のみ（SPEC-038）
        scopeType: 0,
        scope_type: 0,
        goodOrBad: data.goodOrBad,
        importance: data.importance,
        extraContents: [],
      };
      this.editData.extraContents.forEach((rec) => {
        updateData.extraContents.push({
          contentType: rec.contentType || rec.content_type,
          content: rec.content,
        });
      });

      Promise.resolve()
        .then((a) => {
          return this.checkAuthToken();
        })
        .then((a) => {
          return ReportEntryAPI.update(updateData, self.propReportId);
        })
        .then((a) => {
          self.updating = false;
          console.log("日報を更新しました。");
          finishCb();
        })
        .catch(function (err) {
          self.updating = false;
          console.log(err);
          self.showErrorToast("データの更新に失敗しました。");
        });
    },

    backToList() {
      let url = this.buildUrl("/entry", { dt: this.propReportDate });
      this.$router.push(url);
    },

    onFileInputChanged(files) {
      let self = this;

      console.log("onFileInputChanged");
      console.log(files);

      let progressFunc = function (progress) {
        console.log("uploadFile progress:" + progress);
      };

      FileUploadAPI.uploadFile(files, progressFunc)
        .then((a) => {
          //console.log("ファイルをアップロードしました。");
          //console.log(a);
          let fileId = a.data && a.data.fileId ? a.data.fileId : a.data;
          self.editData.files.push(fileId);
          self.selected_file = null;
        })
        .catch(function (err) {
          console.log(err);
          self.showErrorToast("データの更新に失敗しました。");
        });
    },

    onFileDeleteClick(fileId) {
      //console.log("onFileDeleteClick id:" + fileId);
      let idx = this.editData.files.indexOf(fileId);
      if (idx > -1) {
        this.editData.files.splice(idx, 1);
      }
    },

    onFileDrop(files) {
      this.uploadFiles(files);
    },

    uploadFiles(files) {
      let targetFiles = [];

      if (files) {
        if (files instanceof FileList) {
          for (let i = 0; i < files.length; i++) {
            let file = files[i];
            targetFiles.push(file);
          }
        } else {
          targetFiles.push(files);
        }
      } else return;

      // 上限を超えるファイルは送信せずに知らせる（サーバでも400で弾かれる）
      let oversizedFiles = targetFiles.filter((file) => file.size > MAX_FILE_SIZE_BYTES);
      if (oversizedFiles.length > 0) {
        let names = oversizedFiles.map((file) => file.name).join("、");
        this.showErrorToast("ファイルサイズが上限（" + MAX_FILE_SIZE_MB + "MB）を超えています。" + names);
        targetFiles = targetFiles.filter((file) => file.size <= MAX_FILE_SIZE_BYTES);
      }

      let self = this;
      targetFiles.forEach((file) => {
        console.log(file);

        let progressFunc = function (progress) {
          console.log("uploadFile progress:" + progress);
        };

        Promise.resolve()
          .then((a) => {
            return this.checkAuthToken();
          })
          .then((a) => {
            return FileUploadAPI.uploadFile(file, progressFunc);
          })
          .then((a) => {
            let fileId = a.data && a.data.fileId ? a.data.fileId : a.data;
            console.log("ファイルをアップロードしました。fileId:" + fileId);
            //                    console.log(a);

            self.editData.files.push(fileId);
          })
          .catch(function (err) {
            console.log(err);
            self.showErrorToast("データの更新に失敗しました。");
          });
      });
    },

    tagSearch(inputValue) {
      console.log("tagSearch " + inputValue);

      let self = this;

      if (self.tag_ac.isLoading) {
        self.tag_ac.needReload = true;
        return;
      }

      //console.log("tagSearch");
      //console.log(inputValue);

      self.tag_ac.isLoading = true;
      self.tag_ac.needReload = false;

      Promise.resolve()
        .then((a) => {
          return this.checkAuthToken();
        })
        .then((a) => {
          return TagAPI.listTags(inputValue);
        })
        .then((response) => {
          self.tag_ac.autocompleteList.splice(0);
          response.data.forEach((rec) => {
            self.tag_ac.autocompleteList.push(rec.name);
          });
        })
        .catch(function (err) {
          console.log(err);
          self.tag_ac.needReload = false;
          self.showErrorToast("データの取得に失敗しました。");
        })
        .finally(() => {
          self.tag_ac.isLoading = false;

          if (self.tag_ac.needReload) {
            self.tagSearch(self.editData.inputTag);
          }
        });
    },
  },
};
</script>

<style lang="scss"></style>
